import { useSelector as rawUseSelector } from 'react-redux';

import { AppState } from 'src/store';

type Selector<T> = (state: AppState) => T;

export function useSelector<TSelected = unknown>(selector: Selector<TSelected>) {
  return rawUseSelector<AppState, TSelected>(selector);
}
